import { useQueryClient } from "@tanstack/react-query";
import Cookies from "js-cookie";

import { useTranslation } from "../../core/translation.core";
import useRetailShop from "../../hooks/useRetailShop";
import { setShopRetailId } from "../../core/retailShop.core";
import useRetailShops from "../../hooks/useRetailShops";

export const selectCss =
  "px-3 py-2 " + //
  "rounded border border-[#CCCCCC] " +
  "text-black dark:text-her-gray dark:bg-her-backblue ";

export const profileGridCss = "grid grid-cols-1 md:grid-cols-[200px_200px] items-center";

export default function PosShopSelector() {
  const { t, msg } = useTranslation();
  const pos = useRetailShop();
  const queryClient = useQueryClient();
  const { data, isLoading, isError } = useRetailShops();

  function changeLocale(value: string) {
    const selectedRetail = data?.find((r: any) => r.id === value);
    if (selectedRetail) {
      setShopRetailId(selectedRetail.shopId, value);
      Cookies.remove("posCartId");
      queryClient.invalidateQueries({ queryKey: ["retailShopId"] });
      queryClient.invalidateQueries({ queryKey: ["retailShops"] });
      window.location.reload();
    }
  }

  if (
    (!isLoading && !data) || // server side
    isLoading // client side
  ) {
    return (
      <div className={profileGridCss}>
        <h2 className="dark:text-white">{t(msg.setting.selectRetailShop)}</h2>
        <div>Loading...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={profileGridCss}>
        <h2 className="dark:text-white">{t(msg.setting.selectRetailShop)}</h2>
        <div>Error loading retail shops</div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className={profileGridCss}>
        <h2 className="dark:text-white">{t(msg.setting.selectRetailShop)}</h2>
        <div>No retail shops available</div>
      </div>
    );
  }

  const groupedRetails = data.reduce((acc: any, retail: any) => {
    const shopName = retail.shopName || "Unknown Shop";
    if (!acc[shopName]) {
      acc[shopName] = [];
    }
    acc[shopName].push(retail);
    return acc;
  }, {});

  return (
    <div className={profileGridCss}>
      <h2 className="dark:text-white">{t(msg.setting.selectRetailShop)}</h2>
      <select id="select-pos" className={selectCss} onChange={(e) => changeLocale(e.target.value)} value={pos?.id}>
        {Object.entries(groupedRetails).map(([shopName, retails]: [string, any]) => (
          <optgroup key={shopName} label={shopName}>
            {retails.map((retail: any) => (
              <option key={retail.id} value={retail.id}>
                {retail.name}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
}
